/** MotionX design tokens — canvas/runtime; UI uses CSS variables in globals.css */
export const mx = {
  skeleton:     '#8ecfc3',
  skeletonDim:  '#6aab9f',
  skeletonFace: '#b8c4ce',
} as const;

export function scoreTier(score: number) {
  if (score >= 90) return { label: '优秀', color: 'var(--mx-success)' };
  if (score >= 70) return { label: '良好', color: 'var(--mx-accent)' };
  if (score >= 50) return { label: '一般', color: 'var(--mx-warning)' };
  return { label: '待改进', color: 'var(--mx-danger)' };
}

export interface SkeletonPalette {
  primary: string;
  secondary: string;
  face: string;
}

export interface StagePalette {
  top: string;
  mid: string;
  bottom: string;
  grid: string;
  scan: string;
  vignette: string;
}

function cssVar(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export function readSkeletonPalette(): SkeletonPalette {
  return {
    primary:   cssVar('--mx-skeleton', mx.skeleton),
    secondary: cssVar('--mx-skeleton-dim', mx.skeletonDim),
    face:      cssVar('--mx-skeleton-face', mx.skeletonFace),
  };
}

export function readStagePalette(): StagePalette {
  return {
    top:      cssVar('--mx-stage-top', '#0e1116'),
    mid:      cssVar('--mx-stage-mid', '#0e1116'),
    bottom:   cssVar('--mx-stage-bottom', '#0b0d10'),
    grid:     cssVar('--mx-stage-grid', 'rgba(109,181,168,0.14)'),
    scan:     cssVar('--mx-stage-scan', 'rgba(109,181,168,0.04)'),
    vignette: cssVar('--mx-stage-vignette', 'rgba(0,0,0,0.55)'),
  };
}

export function jointColor(index: number, palette: SkeletonPalette): string {
  if (index <= 4) return palette.face;
  if ([5, 6, 11, 12].includes(index)) return palette.primary;
  return palette.secondary;
}
